import script from "./SoundEffectConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./SoundEffectConfig.vue?vue&type=script&setup=true&lang=js"

import "./SoundEffectConfig.vue?vue&type=style&index=0&id=7bc1d86a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc1d86a"]])

export default __exports__